import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'valetFormat',
    pure: true,
    standalone: false
})
export class ValetFormatPipe implements PipeTransform {
  transform(row: any, ...args: unknown[]): string {
    return row.valet ? `${row.valet.firstName} ${row.valet.lastName}` : '';
  }
}